// extracted by mini-css-extract-plugin
module.exports = {"container":"Logos_container__5bik7","inner":"Logos_inner__ADYDw","title":"Logos_title__nURk_","logos":"Logos_logos__NZB9c","logo":"Logos_logo__0EpXC"};